module.exports = __webpack_public_path__ + "media/images/menu/elara-8d81c84112a6ad98b9d6865c35a8d666.jpg";